import { algoliasearch } from 'algoliasearch';
import once from 'lodash-es/once';

export interface AlgoliaConfig {
  algoliaEnv: string;
  apiKey: string;
  appId: string;
  url?: string;
}

export const getAlgoliaClient = once(
  ({ apiKey, appId, url }: Omit<AlgoliaConfig, 'algoliaEnv'>) => {
    return algoliasearch(appId, apiKey, {
      /** @see https://www.algolia.com/doc/api-reference/api-methods/configuring-timeouts/?client=javascript */
      timeouts: {
        /**
         * Connection timeout in milliseconds.
         * @default 2_000
         */
        connect: 4_000,
        /**
         * Read timeout in milliseconds.
         * @default 5_000
         */
        read: 5_000,
        /**
         * Write timeout in milliseconds.
         * @default 30_000
         */
        write: 30_000,
      },
      ...(url
        ? {
            hosts: [{ accept: 'read', protocol: 'https', url }],
          }
        : {}),
    });
  }
);
